<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="上调价格(请输入小数,如0.16)" prop="percentage">
      <a-input-number v-model="form.data.percentage"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { _goldPriceUpdate, } from '@/api/websiteGoodsApi';

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _goldPriceUpdate({
        percentage: this.percentage,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsPriceUpdate',
  props: {
    transportInfoId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    transportInfoId() {
      if (this.transportInfoId) {
        this.getTransportInfo();
      }
    },
  },
  methods: {
    onAdd,
    onCancel,
  },
  data() {
    return {
      form: {
        data: {
          percentage: 0,
        },
        rules: {
          percentage: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
};
</script>
